
function openModalVoting(){
	if (!$('.media-voting-box').length) {
		return false;
	}
	$('.js-open-modal-voting').on('click', function(){
		let modalBox = $('.media-voting-box');
		if (!modalBox.hasClass('media-voting-box--open')) {
			modalBox.addClass('media-voting-box--open');
		} else {
			modalBox.removeClass('media-voting-box--open');
		}
	});

	$('.js-close-modal-voting').on('click', function(){
		let modalBox = $('.media-voting-box');
		if (!modalBox.hasClass('media-voting-box--open')) {
			modalBox.addClass('media-voting-box--open');
		} else {
			modalBox.removeClass('media-voting-box--open');
		}
	});

	
	
}



/**
 * Инит модуля
 */
function init() {
	openModalVoting();
}

module.exports = {
	init,
};
